module.exports = __webpack_public_path__ + "img/back_inseam.11f1df0f.png";